export default __webpack_public_path__ + "static/Roobert-Light-334549c05b7f3c4dd3bc98a85473be98.woff2";